import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    refresh: 0,
    data: [],
    dropdown: []
}

const uiSlice = createSlice({
    initialState,
    name: "attrbiute",
    reducers: {
        set_data: (state, action) => {
            state.data = action.payload
        },
        set_drop_down: (state, action) => {
            state.dropdown = action.payload
        },
        reset_attribute_list:(state,action)=>{
            return initialState
        }
    }
})

export default uiSlice.reducer;

export const {
    set_data,
    reset_attribute_list,
    set_drop_down
} = uiSlice.actions;
